import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { ContactInfo } from "./query";

type Props = {
	hotelID: string;
};

export const useFetchContactInfo = ({ hotelID }: Props) => {
	return useCustomSuspenseQuery(ContactInfo, { variables: { hotelID } });
};
